import {FC, useState} from 'react'
import Product from "./Product"

interface Props {
    category:any,
    booking:Booking,
    setBooking:Function
}

const Category: FC<Props> = ({category, booking, setBooking}) => {

    const [showAll, setShowAll] = useState(false);
    if(category.products.featured === false) {
        category.products.featured = category.products.standard.splice(0,1)
    }

    // Don't show when product count is 0
    if(category.products.featured.length + category.products.standard.length === 0)
        return

    return (
        <>
            <h3 className={(category.products.standard.length > 0) ? 'cursor-pointer' : ''} onMouseDown={() => setShowAll(!showAll)}>
                {category.name}
            </h3>
            <div className={'options'}>
                <div className={'featured'}>
                    {category.products.featured.map((product:any, i:number) => (
                        <Product key={i} product={product} booking={booking} setBooking={setBooking} />
                    ))}
                </div>
                {category.products.standard.length > 0 && (
                    <div className={showAll ? 'standard' : 'standard hide'}>
                        <div className={'expand-cat cursor-pointer'} onMouseDown={() => setShowAll(!showAll)}>
                            <div className={'expand-cat instructions'}>
                                <span className={'txt'}/>
                                <span className={showAll ? 'category-all open' : 'category-all'}>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6"><path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" /></svg>
                                </span>
                            </div>
                        </div>
                        {category.products.standard.map((product:any, i:number) => (
                            <Product key={i} product={product} booking={booking} setBooking={setBooking} />
                        ))}
                    </div>
                )}
            </div>
        </>
    )
};

export default Category
